module.exports = __webpack_public_path__ + "img/yywy-1.cabe038.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/yywy-1.jpg
// module id = mc4/
// module chunks = 0